import { render, staticRenderFns } from "./ProductTermsAndConditions.vue?vue&type=template&id=65164522&scoped=true&"
import script from "./ProductTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./ProductTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./ProductTermsAndConditions.vue?vue&type=style&index=0&id=65164522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65164522",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VDivider,VFlex,VLayout})
